import { useMutation } from '@tanstack/react-query';

import { usePatronSession } from '@app/hooks';
import { makeRequest } from '@app/utils';

interface UseSaveSearchMutationProps {
  savedSearch: {
    query: string;
    date: string;
    resultCount: number;
    interface: string;
    searchType: string;
    requestParams: string;
  };
}

export const useSaveSearches = () => {
  const { externalSystemId = '' } = usePatronSession();
  const url = `/opac-patron/account/${externalSystemId}/searches`;

  return useMutation(({ savedSearch }: UseSaveSearchMutationProps) =>
    makeRequest({
      url,
      method: 'POST',
      data: [savedSearch],
    })
  );
};

export const useUnsaveSearches = () => {
  const { externalSystemId = '' } = usePatronSession();
  const url = `/opac-patron/account/${externalSystemId}/searches`;

  return useMutation((savedSearchId: string) =>
    makeRequest({
      url,
      method: 'DELETE',
      data: {
        params: {
          searchIds: savedSearchId,
        },
      },
    })
  );
};
